import BaseAdditionalExpenseRecord from "@/models/server/AdditionalExpenseRecords/BaseAdditionalExpenseRecord";

export default class ServiceAdditionalExpenseRecord extends BaseAdditionalExpenseRecord {
    public serviceReportId: string | null = null;

    public serviceReport: string | null = null;

    public isServiceAdditionalExpenseRecord: true = true;

    public static is(from?: object | null): boolean {
        // noinspection PointlessBooleanExpressionJS
        return (from != null) && ((from instanceof ServiceAdditionalExpenseRecord) || ((from as any).isServiceAdditionalExpenseRecord === true));
    }

    public static hasDuplicatedAdditionalExpenses(additionalExpenseRecords: ServiceAdditionalExpenseRecord[]): boolean {
        const expenseRecord: string[] = additionalExpenseRecords
            .map(expense => expense.name.toLowerCase().trim());

        const duplicates: string[] = expenseRecord
            .filter((expense, index, self) => self.indexOf(expense) !== index);

        return duplicates.length > 0;
    }

    public static isAdditionalExpensesValid(additionalExpenses: ServiceAdditionalExpenseRecord[] | null): boolean {
        if (additionalExpenses == null || additionalExpenses.length == 0) {
            return true;
        }

        if (this.hasDuplicatedAdditionalExpenses(additionalExpenses)) {
            return false;
        }

        return additionalExpenses
            .every(expense => this.isValid(expense))
    }
}